import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'uikit/buttons';

import styles from '../styles/uikitContentMarkdown.module.scss';

const MarkdownMention = ({
  id,
  name,
  onClick,
}) => (
  <Button
    className={styles.mention}
    variant="link"
    text={`@${name}`}
    onClick={() => onClick(id)}
    color="primary"
  />
);

MarkdownMention.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default React.memo(MarkdownMention);
